import React, { useEffect, useState } from "react";
import { Box, Button, Link, Slide } from "@mui/material";

type ChildProps = {
  onButtonClick: () => void;
};
const BottomBtn: React.FC<ChildProps> = ({ onButtonClick }) => {

  const [scrollHeight, setScrollHeight] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = window.scrollY;
      setScrollHeight(scrollHeight);
    };

    window.addEventListener('scroll', handleScroll);

    // 清理事件监听器
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <Slide direction="up" in={scrollHeight > 300}>
      <Box display={scrollHeight > 300 ? 'block' : 'none'} sx={{ position: "fixed", bottom: 20, right: '20px', left: '20px' }} >
        <Button onClick={onButtonClick}
          fullWidth variant="contained" sx={{ mt: 1, borderRadius: 2, bgcolor: '#00a173', border: 0, }}>

          <span className="insert-text text-[#FFF]">
            Instal
          </span>

        </Button>
      </Box>
    </Slide>
  )
}

export default BottomBtn